import noop from 'lib/function/noop'
import { createContext } from 'react'

type UserAnalyticsAction = (action: string, label?: string) => void

const UserAnalyticsActionContext = createContext<UserAnalyticsAction>(noop)

export default UserAnalyticsActionContext
